import { IdentificationStatusResponseKycStatus } from "@/services/model";
import {
  isIdCheckPageActionable,
  isKycUnsettled,
  isRetryIdCheckStatus,
} from "@/utils/kycTodoConfig";

type AddDeviceSuccessNextStep =
  | { type: "wait" }
  | { type: "idCheck"; fromOrder: boolean }
  | { type: "personalData" }
  | { type: "cockpit" };

/**
 * Maps KYC status after add-device checkout to the handoff page's next action.
 * `wait` = keep thank-you UI and keep polling (unsettled / fraud check).
 */
export const getAddDeviceSuccessNextStep = (
  kycStatus: string | undefined,
  isVerified?: boolean,
): AddDeviceSuccessNextStep => {
  if (
    isKycUnsettled(kycStatus) ||
    kycStatus === IdentificationStatusResponseKycStatus.FRAUD_CHECK_PENDING
  ) {
    return { type: "wait" };
  }

  if (
    isVerified === true &&
    kycStatus === IdentificationStatusResponseKycStatus.OK
  ) {
    return { type: "cockpit" };
  }

  if (kycStatus === IdentificationStatusResponseKycStatus.OPEN) {
    return { type: "idCheck", fromOrder: true };
  }

  if (isRetryIdCheckStatus(kycStatus)) {
    return { type: "idCheck", fromOrder: false };
  }

  if (kycStatus === IdentificationStatusResponseKycStatus.KYC_data_mismatch) {
    return { type: "personalData" };
  }

  // PENDING, underaged, max attempts, unknown non-actionable → cockpit todos
  if (!isIdCheckPageActionable(kycStatus)) {
    return { type: "cockpit" };
  }

  // Unknown actionable status: treat like OPEN without order framing
  return { type: "idCheck", fromOrder: false };
};
